import type { ExcelDownloadClient, ExcelDownloadResult } from "app/components/React/ExcelButton/ExcelClientDownload";
import type { FindAppsDescriptionDto } from "app/pages/sales-intelligence/modules/find-apps-filters/types/description.dto";
import { AppsSourceType } from "app/pages/sales-intelligence/store/find-apps/types/appsSourceType";
import type { GetRequestOptions, IFetchService, PostConfigObject } from "app/services/fetchService";

import type {
    AppsColumnConfigDto,
    AppsColumnSelectionRequestDto,
    AppsExcelDownloadRequestDto,
    IFindAppsAndroidRequestDto,
    IFindAppsIosRequestDto,
    IFindAppsResponseDto,
} from "../../../../store/find-apps/types/dto";

export default function createFindAppsApiService(
    fetchService: IFetchService,
    excelDownloadClient: ExcelDownloadClient,
) {
    return {
        [AppsSourceType.AppleStore]: {
            fetchColumnConfig(options?: Readonly<GetRequestOptions>): Promise<AppsColumnConfigDto> {
                return fetchService.get("/sales-api/search-apps/ios/columns", undefined, options);
            },

            saveColumnSelection(dto: Readonly<AppsColumnSelectionRequestDto>): Promise<void> {
                return fetchService.put("/sales-api/search-apps/ios/columns", dto);
            },

            exportToExcel(dto: Readonly<AppsExcelDownloadRequestDto>): Promise<ExcelDownloadResult> {
                return excelDownloadClient("sales-api/search-apps/ios/excel", dto);
            },
        },

        [AppsSourceType.GoogleStore]: {
            fetchColumnConfig(options?: Readonly<GetRequestOptions>): Promise<AppsColumnConfigDto> {
                return fetchService.get("/sales-api/search-apps/android/columns", undefined, options);
            },

            saveColumnSelection(dto: Readonly<AppsColumnSelectionRequestDto>): Promise<void> {
                return fetchService.put("/sales-api/search-apps/android/columns", dto);
            },

            exportToExcel(dto: Readonly<AppsExcelDownloadRequestDto>): Promise<ExcelDownloadResult> {
                return excelDownloadClient("sales-api/search-apps/android/excel", dto);
            },
        },

        fetchAndroidAppsData(
            params: Partial<IFindAppsAndroidRequestDto>,
            options?: Readonly<PostConfigObject>,
        ): Promise<IFindAppsResponseDto> {
            return fetchService.post("/sales-api/search-apps/android", params, options);
        },

        fetchIosAppsData(
            params: Partial<IFindAppsIosRequestDto>,
            options?: Readonly<PostConfigObject>,
        ): Promise<IFindAppsResponseDto> {
            return fetchService.post("/sales-api/search-apps/ios", params, options);
        },

        fetchDescription(options?: Readonly<GetRequestOptions>): Promise<FindAppsDescriptionDto> {
            return fetchService.get("/sales-api/search-apps/description", undefined, options);
        },
    };
}
